import React from "react";
import SearchImage from "../images/Search.png";
import PaginationBar from "../../InventoryManagement/components/Common/PaginationBar";

const LeadsTable = ({
  data,
  loading = false,
  page,
  pageCount,
  onPageChange,
  onDetailsClick,
  error,
  totalCount = 0,
}) => {
  const headers = [
    "Merchant Wallet",
    "Merchant Name",
    "Account Type",
    "Migration Request ID",
    "Request Date",
    "Request Status",
    "",
  ];

  const StatusPill = ({ status, statusText }) => {
    let tone = "";
    switch (status?.toLowerCase()) {
      case "requested":
        tone = "status-pill-requested";
        break;
      case "cs_layer1_approved":
        tone = "status-pill-l2-pending";
        break;
      case "cs_layer1_rejected":
        tone = "status-pill-rejected";
        break;
      case "cs_layer2_rejected":
        tone = "status-pill-l1-correction-pending";
        break;
      case "cs_layer2_approved":
        tone = "status-pill-approved";
        break;
      case "cs_layer2_sent_back":
        tone = "status-pill-sent-back";
        break;
      default:
        tone = "status-pill-default";
        break;
    }
    return <span className={`status-pill ${tone}`}>{statusText}</span>;
  };

  const SkeletonRow = () => (
    <tr className="row">
      {headers.map((_, i) => (
        <td key={i} className="cell">
          <div className="skeleton" />
        </td>
      ))}
    </tr>
  );

  return (
    <div className="wrapper">
      <div className="leads-table-container">
        {loading ? (
          <table className="leads-table">
            <thead>
              <tr className="leads-header-row">
                {headers.map((h) => (
                  <th key={h} className="leads-header-cell">
                    {h}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {Array.from({ length: 10 }).map((_, i) => (
                <SkeletonRow key={`skeleton-${i}`} />
              ))}
            </tbody>
          </table>
        ) : error ? (
          <div className="error-container">
            <img src={SearchImage} alt="" className="error-image" />
            <h2 className="error-title">Error fetching data</h2>
            <p className="error-message">Please try again.</p>
          </div>
        ) : !loading && data.length === 0 ? (
          <div className="error-container">
            <img src={SearchImage} alt="" className="error-image" />
            <h2 className="error-title">No Data Found</h2>
            <p className="error-message">Please try again.</p>
          </div>
        ) : (
          <table className="leads-table">
            <thead>
              <tr className="leads-header-row">
                {headers.map((h) => (
                  <th key={h} className="leads-header-cell">
                    {h}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data.map((row, idx) => (
                <tr
                  key={`${row.request_id || "migration"}-${idx}`}
                  className="leads-row"
                >
                  <td className="leads-cell">{row.wallet_number || "-"}</td>
                  <td
                    className="leads-cell leads-cell-truncate"
                    title={row.merchant_name || "-"}
                  >
                    {row.merchant_name || "-"}
                  </td>
                  <td className="leads-cell leads-cell-thin">
                    {row.account_type || "-"}
                  </td>
                  <td className="leads-cell">{row.request_id || "-"}</td>
                  <td className="leads-cell leads-cell-thin">
                    {row.requested_date || "-"}
                  </td>
                  <td className="leads-cell">
                    <StatusPill
                      status={row.raw_status}
                      statusText={row.request_status}
                    />
                  </td>
                  <td className="leads-cell">
                    <button
                      className="details-button"
                      onClick={() => {
                        onDetailsClick(row.bank_info_id);
                      }}
                    >
                      Details
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {!loading && (
        <PaginationBar
          page={page}
          setPage={onPageChange}
          totalPages={pageCount}
          totalCount={totalCount}
        />
      )}
    </div>
  );
};

export default LeadsTable;
